import { render, staticRenderFns } from "./RequestsNew.vue?vue&type=template&id=6a6c70f0&scoped=true"
import script from "./RequestsNew.vue?vue&type=script&lang=ts"
export * from "./RequestsNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestsNew.vue?vue&type=style&index=0&id=6a6c70f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c70f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6c70f0')) {
      api.createRecord('6a6c70f0', component.options)
    } else {
      api.reload('6a6c70f0', component.options)
    }
    module.hot.accept("./RequestsNew.vue?vue&type=template&id=6a6c70f0&scoped=true", function () {
      api.rerender('6a6c70f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companyContractors/RequestsNew.vue"
export default component.exports